import * as types from '../const/action.types';
import { get, put, post, del } from '../api/_basic';

export function loadEmployees(local, filter, sign, desactivados) {
    let url = `${process.env.REACT_APP_API_EMPLOYEE}`;
    if (local || filter || sign || desactivados) {
        url = url + (filter ? `?filtro=${filter}` : '');
        url = url + (local ? (url.indexOf('?') > 0 ? '&' : '?') + `local=${local}` : '');
        url = url + (sign ? (url.indexOf('?') > 0 ? '&' : '?') + `consentimiento=true` : '');
        url = url + (desactivados ? (url.indexOf('?') > 0 ? '&' : '?') + `desactivados=true` : '');
    }
    return async (dispatch) => {
        dispatch(employeesHasErrored(false, ''));
        dispatch(employeesIsLoading(true));
        return get(url)
            .then((response) => {
                dispatch(employeesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(employeesHasErrored(false, ''));
                dispatch(loadEmployeesSuccess(items));
            })
            .catch((error) => {
                dispatch(employeesIsLoading(false));
                dispatch(employeesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addEmployee(employee) {
    return async (dispatch) => {
        dispatch(employeeIsSaving(true));
        return post(`${process.env.REACT_APP_API_EMPLOYEE}`, employee)
            .then((response) => {
                dispatch(employeeIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editEmployee(employee) {
    return async (dispatch) => {
        dispatch(employeeIsSaving(true));
        return put(`${process.env.REACT_APP_API_EMPLOYEE}/${employee.id}`, employee)
            .then((response) => {
                dispatch(employeeIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function deleteEmployee(employee) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_EMPLOYEE}/${employee}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadInfo(employee) {
    return async function(dispatch) {
        dispatch(employeesHasErrored(false, ''));
        dispatch(employeesIsLoading(true));
        return get(`${process.env.REACT_APP_API_EMPLOYEE}/${employee}`)
            .then((response) => {
                dispatch(employeesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(employeesHasErrored(false, ''));
                dispatch(loadEmployeeSuccess(item));
            })
            .catch((error) => {
                //throw error;
                dispatch(employeesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadEmployeeSuccess(data) {
    return {
        type: types.LOAD_EMPLOYEE_SUCCESS,
        data,
    };
}

export function loadEmployeesSuccess(data) {
    return {
        type: types.EMPLOYEES_SUCCESS,
        data,
    };
}

export function employeesHasErrored(bool, message) {
    return {
        type: types.EMPLOYEES_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function employeesIsLoading(bool) {
    return {
        type: types.EMPLOYEES_IS_LOADING,
        isLoading: bool,
    };
}

export function employeeIsSaving(bool) {
    return {
        type: types.EMPLOYEES_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/employee.actions.js